import React, { useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import UserControl from "./UserControl";
import NavbarToggle from "./NavbarToggle";
import { Link } from "react-router-dom";
import ShoppingCart from "../pages/ShoppingCart";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { showNavUserAction } from "../store/actions/showNavUserAction";
import { showNavAction } from "../store/actions/showNavAction";

function Header() {
  const user = useSelector((state) => state.user_auth);
  const [UserControlShow, setUserControlShow] = useState(false);
  const dispatch = useDispatch();

  return (
    <>
      <UserControl UserControlShow={UserControlShow} setUserControlShow={setUserControlShow} />
      <NavbarToggle />
      <Navbar bg="light" expand="lg" className="fixed-top high-navbar">
        <Container>
          <button className="btn  d-lg-none" onClick={() => dispatch(showNavAction())}>
            <span className="navbar-toggler-icon"></span>
          </button>
          <Navbar.Brand>
            <Link to="/" className="fs-5 d-flex align-items-center navbar-brand">
              <span className="logo_diferent">The </span>
              <span className="logo">Wine </span>
              <span className="logo_diferent">Cabinet</span>
            </Link>
          </Navbar.Brand>

          <Navbar.Collapse id="basic-navbar-nav">
            <div className="d-flex justify-content-around w-100">
              <Nav className="nav--black gap-2 ">
                <motion.div
                  whileHover={{ scale: 1.1 }}
                  style={{
                    cursor: "pointer",
                  }}
                  className="me-4"
                >
                  <Link to="/">Inicio</Link>
                </motion.div>
                <motion.div
                  whileHover={{ scale: 1.1 }}
                  style={{
                    cursor: "pointer",
                  }}
                  className="me-4"
                >
                  <Link to="/productos">Productos</Link>
                </motion.div>
                <motion.div
                  whileHover={{ scale: 1.1 }}
                  style={{
                    cursor: "pointer",
                  }}
                  className="me-4"
                >
                  <div id="animated-example" className="animated bounce">
                    <Link to="/sobre-nosotros">Sobre este proyecto</Link>
                  </div>
                </motion.div>
              </Nav>
            </div>
          </Navbar.Collapse>
          <Nav>
            <div className="d-flex menu-items align-items-center">
              <Nav onClick={() => dispatch(showNavUserAction())}>
                {user.token ? (
                  <div className="d-flex align-items-center justify-content-center w-100">
                    <span className="pe-1" style={{ fontFamily: "Lobster Two, cursive" }}>
                      Hola {user.firstName}!
                    </span>
                    <svg
                      style={{ cursor: "pointer" }}
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      width="1em"
                      height="1em"
                      viewBox="0 0 24 24"
                      fill="green"
                    >
                      <path d="M16.848 12.168c1.56-1.32 2.448-3.216 2.448-5.232 0-3.768-3.072-6.84-6.84-6.84s-6.864 3.072-6.864 6.84c0 2.016 0.888 3.912 2.448 5.232-4.080 1.752-6.792 6.216-6.792 11.136 0 0.36 0.288 0.672 0.672 0.672h21.072c0.36 0 0.672-0.288 0.672-0.672-0.024-4.92-2.76-9.384-6.816-11.136zM12.432 1.44c3.048 0 5.52 2.472 5.52 5.52 0 1.968-1.056 3.792-2.76 4.776l-0.048 0.024c0 0 0 0-0.024 0-0.048 0.024-0.096 0.048-0.144 0.096h-0.024c-0.792 0.408-1.632 0.624-2.544 0.624-3.048 0-5.52-2.472-5.52-5.52s2.52-5.52 5.544-5.52zM9.408 13.056c0.96 0.48 1.968 0.72 3.024 0.72s2.064-0.24 3.024-0.72c3.768 1.176 6.576 5.088 6.816 9.552h-19.68c0.264-4.44 3.048-8.376 6.816-9.552z"></path>
                    </svg>
                  </div>
                ) : (
                  <svg
                    style={{ cursor: "pointer" }}
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="1em"
                    height="1em"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M16.848 12.168c1.56-1.32 2.448-3.216 2.448-5.232 0-3.768-3.072-6.84-6.84-6.84s-6.864 3.072-6.864 6.84c0 2.016 0.888 3.912 2.448 5.232-4.080 1.752-6.792 6.216-6.792 11.136 0 0.36 0.288 0.672 0.672 0.672h21.072c0.36 0 0.672-0.288 0.672-0.672-0.024-4.92-2.76-9.384-6.816-11.136zM12.432 1.44c3.048 0 5.52 2.472 5.52 5.52 0 1.968-1.056 3.792-2.76 4.776l-0.048 0.024c0 0 0 0-0.024 0-0.048 0.024-0.096 0.048-0.144 0.096h-0.024c-0.792 0.408-1.632 0.624-2.544 0.624-3.048 0-5.52-2.472-5.52-5.52s2.52-5.52 5.544-5.52zM9.408 13.056c0.96 0.48 1.968 0.72 3.024 0.72s2.064-0.24 3.024-0.72c3.768 1.176 6.576 5.088 6.816 9.552h-19.68c0.264-4.44 3.048-8.376 6.816-9.552z"></path>
                  </svg>
                )}
              </Nav>
              <Link to="/ver-pedido" className="ms-2 isDisabled" style={{ color: "#000" }}>
                {" "}
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  width="1em"
                  height="1em"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M23.76 4.248c-0.096-0.096-0.24-0.24-0.504-0.24h-18.48l-0.48-2.4c-0.024-0.288-0.384-0.528-0.624-0.528h-2.952c-0.384 0-0.624 0.264-0.624 0.624s0.264 0.648 0.624 0.648h2.424l2.328 11.832c0.312 1.608 1.848 2.856 3.48 2.856h11.28c0.384 0 0.624-0.264 0.624-0.624s-0.264-0.624-0.624-0.624h-11.16c-0.696 0-1.344-0.312-1.704-0.816l14.064-1.92c0.264 0 0.528-0.24 0.528-0.528l1.968-7.824v-0.024c-0.024-0.048-0.024-0.288-0.168-0.432zM22.392 5.184l-1.608 6.696-14.064 1.824-1.704-8.52h17.376zM8.568 17.736c-1.464 0-2.592 1.128-2.592 2.592s1.128 2.592 2.592 2.592c1.464 0 2.592-1.128 2.592-2.592s-1.128-2.592-2.592-2.592zM9.888 20.328c0 0.696-0.624 1.32-1.32 1.32s-1.32-0.624-1.32-1.32 0.624-1.32 1.32-1.32 1.32 0.624 1.32 1.32zM18.36 17.736c-1.464 0-2.592 1.128-2.592 2.592s1.128 2.592 2.592 2.592c1.464 0 2.592-1.128 2.592-2.592s-1.128-2.592-2.592-2.592zM19.704 20.328c0 0.696-0.624 1.32-1.32 1.32s-1.344-0.6-1.344-1.32 0.624-1.32 1.32-1.32 1.344 0.624 1.344 1.32z"></path>
                </svg>
              </Link>
              <Nav>
                <ShoppingCart />
                {/* <span className="et-cart-quantity et-quantity count-0 p-1">0 </span> */}
              </Nav>
            </div>
          </Nav>
        </Container>
      </Navbar>
    </>
  );
}

export default Header;
